<template>
  <div class="box">
    <v-tabs v-model="tab" color="#02532e">
      <!-- <v-tab v-for="n in length" :key="n">{{ tabName[n] }}</v-tab> -->
      <v-tab :key="1" class="subtitle-2 tab-live-detail">
        <!-- <v-icon class="pr-2" small>fal fa-file-pdf</v-icon> -->
        info
      </v-tab>
      <v-tab :key="2" class="subtitle-2 tab-live-detail">
        <!-- <v-icon class="pr-2" small>fal fa-file-pdf</v-icon> -->
        PDF Files
      </v-tab>
      <v-tab :key="3" class="subtitle-2 tab-live-detail">
        <!-- <v-icon class="pr-2" small>fal fa-image</v-icon> -->
        Pictures
      </v-tab>
      <v-tab :key="4" class="subtitle-2 tab-live-detail">
        <!-- <v-icon class="pr-2" small>fas fa-link</v-icon> -->
        URL Links
      </v-tab>
      <!-- <v-tab v-for="n in length" :key="n" v-bind:click="changeTab(n)">{{ tabName[n] }}</v-tab> -->
      <v-tab :key="5" class="subtitle-2 tab-live-detail">
        <!-- <v-icon class="pr-2" small>fas fa-link</v-icon> -->
        Poll
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-overlay absolute v-if="loading">
        <v-progress-circular
          indeterminate
          color="#fff0f2"
          :size="50"
        ></v-progress-circular>
      </v-overlay>
      <v-tab-item :key="1">
        <v-card-text>
          <h2 class="tab-header">{{ courseTitle }}</h2>
          <!-- <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat atque odit itaque in minima asperiores at aperiam quo quidem eius voluptates, nisi voluptatum id velit ratione corrupti dolorum maxime sint.</p> -->
          <h3 class="info-header">Teacher</h3>
          <div
            v-for="teacher in teachers"
            :key="teacher._id"
            class="avatar-with-name"
          >
            <div class="avatar size-m">
              <!-- <img src="https://source.unsplash.com/100x100/?portrait" alt /> -->
              <img :src="teacher.image" />
            </div>
            <p>
              <strong>{{ teacher.displayName }}</strong>
              <span>{{ teacher.description }}</span>
            </p>
          </div>
        </v-card-text>
      </v-tab-item>
      <v-tab-item :key="2">
        <!-- <h2 class="tab-header">List pdf file</h2> -->
        <v-card-text>
          <PdfTab />
        </v-card-text>
      </v-tab-item>
      <v-tab-item :key="3">
        <!-- <h2 class="tab-header">Gallery photos</h2> -->
        <v-card-text>
          <ImageTab />
        </v-card-text>
      </v-tab-item>
      <v-tab-item :key="4">
        <!-- <h2 class="tab-header">List Website</h2> -->
        <v-card-text>
          <WebTab />
        </v-card-text>
      </v-tab-item>
      <v-tab-item :key="5">
        <v-card-text>
          <PollTab :setLoading="setLoading" />
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>

    <!-- <v-card-text class="text-center">
    <v-divider class="mx-4" vertical></v-divider>-->
    <!-- <div v-if="tab===0">
    <v-card-text class="text-center">
      <v-divider class="mx-4" vertical></v-divider>
      <div v-if="tab===0">
        
     <div class="box">
    <ul class="img-view">
      <li v-for="url in images" v-bind:key="url" v-on:click="() => {selectImage(url)}">
        <i class="lni lni-frame-expand"></i>
        <img :src="url.url" alt />
      </li>
    </ul>
  </div>

      </div>
      <div v-if="tab===1">
        <embed :src="pdfs[0].url" type="application/pdf" width="100%" height="100%" />
      </div>
    <p v-if="tab===2">3</p>-->
    <!-- </v-card-text>   -->
  </div>
</template>

<script>
import PdfTab from "@/components/live/PdfTab.vue";
import WebTab from "@/components/live/WebTab.vue";
import PollTab from "@/components/live/PollTab.vue";
import ImageTab from "@/components/live/ImageTab.vue";
import { mapState } from "vuex";

export default {
  components: {
    PdfTab,
    WebTab,
    ImageTab,
    PollTab,
  },
  data: () => ({
    length: 3,
    tab: null,
    tabName: ["", "Image", "PDF", "Website"],
    current: 1,
    loading: false,
  }),
  computed: {
    ...mapState({
      courseTitle: (state) => {
        console.log("state.liveDetail ::: ", state.liveDetail);
        return state.liveDetail ? state.liveDetail.title : "";
      },
    }),
    teachers() {
      if (
        this.$store.getters.liveDetail &&
        this.$store.getters.liveDetail.teacher
      ) {
        return this.$store.getters.liveDetail.teacher;
      } else {
        return [];
      }
    },
    liveDetail() {
      return this.$store.getters.liveDetail;
    },
    pdfs() {
      return this.$store.getters.livePdfs;
    },
    images() {
      return this.$store.getters.liveImages;
    },
    websites() {
      return this.$store.getters.liveWebsites;
    },
  },
  watch: {
    length(val) {
      this.tab = val - 1;
    },
  },
  mounted() {},
  methods: {
    setLoading(flag) {
      this.loading = flag;
    },
    changeTab() {
      console.log(this.test);
    },
    selectImage(url) {
      this.$store.commit("updateImageSelected", url);
      this.$store.commit("setDialogImageLectureClass", {
        className: "open",
        url,
      });
    },
  },
};
</script>
<style scope>
/* .v-window-item {
  padding: 24px;
} */
</style>
<style lang="scss">
.main.container {
  .v-tabs-slider-wrapper {
    width: 0% !important;
  }

  .v-slide-group__wrapper {
    contain: initial;
    overflow: visible;
  }

  .tab-live-detail:not(.v-tab--active) {
    background: #f5f5f5;
    color: black;
  }

  // .v-tab--active {
  //   background: #fff;
  //   color: #e77b9f;
  //   position: relative;

  //   &:after {
  //     content: "";
  //     position: absolute;
  //     left: 0;
  //     bottom: -2px;
  //     z-index: 1;
  //     width: 100%;
  //     height: 4px;
  //     background: #fff;
  //   }
  // }

  .v-tab--active {
    background: #fff !important;
    color: #009bde;
  }

  .tab-live-detail {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px solid #dcdcdc;
    margin-right: 2px;
  }

  .v-tabs-items {
    border: 1px solid #dcdcdc;
    margin-top: -1px;

    h2,
    h3 {
      color: black !important;

      &:after {
        display: none;
      }
    }

    .info-header {
      margin-top: 16px;
    }

    .avatar-with-name {
      padding: 16px;
      background: #f5f5f5;
      border-radius: 4px;
      margin-bottom: 8px;
    }
  }
}
</style>
